import React, { useState, useRef, useEffect } from "react";
import "./index.css"; // External CSS file\imp
import store from "store";
import { Link } from "react-router-dom";
import { imagePrefixUrl } from "util/config";
import AreaSplineChart from "./areaSplineChart";
import GaugeChart from "./gaugeChart";
import moment from "moment";
// import { userSignOut } from "../../appRedux/actions/Auth";

const TraineeHome = () => {
  const [query, setQuery] = useState("");
  const [userStats, setUserStats] = useState(null); // State for API data
  const [allTrainings, setAllTrainings] = useState([]);

  const [loading, setLoading] = useState(true); // State for loading indicator
  const [categories, setCategories] = useState(null); // State for categories
  const [assigned, setAssigned] = useState(null); // State for assigned data
  const [passed, setPassed] = useState(null); // State for passed data
  const [failed, setFailed] = useState(null); // State for failed data
  const [riskScore, setRiskScore] = useState(0);
  const [allTrainingsCard, setAllTrainingsCard] = useState([]);
  const [upcomingTrainings, setUpcomingTrainings] = useState([]);

  let userInfo = store.get("user");
  const formatDateToDDMM = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    return `${day}/${month}`;
  };

  const formatDuration = (seconds) => {
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };
  const truncateWords = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
  };
  const renderTrainingButton = (item) => {
    const isPassed = item.successStatus === "passed";
    const isExpired =
      new Date(item.campaignId.expireAt) < new Date() && !isPassed;

    return (
      <>
        {!isExpired ? (
          <Link
            to={{
              pathname: isPassed
                ? "/trainee/result/" + item.campaignId._id
                : item.campaignId.disableRetry &&
                  item.successStatus === "failed"
                ? ""
                : "/trainee/course-intro/" + item.campaignId._id + "/Assigned",
              trainingInfoProps: item.campaignId.trainingId,
              campaignInfoProps: item,
            }}
            style={{
              pointerEvents:
                item.campaignId.disableRetry && item.successStatus === "failed"
                  ? "none"
                  : "auto",
            }}
          >
            <img
              style={{
                width: "35px",
                marginLeft: "10px",
                cursor: "pointer",
              }}
              src="/assets/Button.png"
              alt="button"
            />
          </Link>
        ) : (
          <img
            style={{
              width: "35px",
              marginLeft: "10px",
              opacity: 0.4,
              filter: "grayscale(100%)",
              cursor: "not-allowed",
            }}
            src="/assets/Button.png"
            alt="button"
          />
        )}
      </>
    );
  };
  // Fetch trainee training info on mount

  const fetchDashboardData = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const url = apiUrl + "api/trainee/dashboard";
    const accessToken = localStorage.getItem("accessToken");

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      });

      if (!res.ok) {
        if (res.status === 401) {
          if (window.message && window.message.error) {
            window.message.error(
              "Your session has been expired. Please relogin."
            );
          }
          localStorage.clear();
          window.location.reload();
          throw new Error("Session expired");
        } else {
          if (window.message && window.message.error) {
            window.message.error("Some error has occurred.");
          }
          throw new Error("API error");
        }
      }

      const data = await res.json();
      if (!data.error) {
        const rawData = data.data || [];
        const categories = rawData.map((item) => item.date);
        const assigned = rawData.map((item) => item.assigned);
        const passed = rawData.map((item) => item.passed);
        const failed = rawData.map((item) => item.failed);

        setCategories(categories);
        setAssigned(assigned);
        setPassed(passed);
        setFailed(failed);
      }
    } catch (err) {
      if (err.message !== "Session expired" && err.message !== "API error") {
        if (window.message && window.message.error) {
          window.message.error("Some error has occurred.");
        }
      }
      console.error("Failed to fetch user stats:", err);
    }
  };
  const getRiskScore = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const url = apiUrl + "api/trainee/userRiskScore";
    const accessToken = localStorage.getItem("accessToken");

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      });

      if (!res.ok) {
        if (res.status === 401) {
          if (window.message && window.message.error) {
            window.message.error(
              "Your session has been expired. Please relogin."
            );
          }
          localStorage.clear();
          window.location.reload();
          throw new Error("Session expired");
        } else {
          if (window.message && window.message.error) {
            window.message.error("Some error has occurred.");
          }
          throw new Error("API error");
        }
      }

      const data = await res.json();
      if (!data.error) {
        const rawData = data.data || [];
        setRiskScore(rawData.avereageRiskScore.toFixed(2));
      }
    } catch (err) {
      if (err.message !== "Session expired" && err.message !== "API error") {
        if (window.message && window.message.error) {
          window.message.error("Some error has occurred.");
        }
      }
      console.error("Failed to fetch user stats:", err);
    }
  };
  const getLatestTrainings = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const url = apiUrl + "api/trainee/latestTrainings";
    const accessToken = localStorage.getItem("accessToken");

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      });

      if (!res.ok) {
        if (res.status === 401) {
          if (window.message && window.message.error) {
            window.message.error(
              "Your session has been expired. Please relogin."
            );
          }
          localStorage.clear();
          window.location.reload();
          throw new Error("Session expired");
        } else {
          if (window.message && window.message.error) {
            window.message.error("Some error has occurred.");
          }
          throw new Error("API error");
        }
      }

      const data = await res.json();
      if (!data.error) {
        console.log("Latest Trainings", data);
        setAllTrainingsCard(data.data);
        setUpcomingTrainings(data.upcomingTrainings);
      }
    } catch (err) {
      if (err.message !== "Session expired" && err.message !== "API error") {
        if (window.message && window.message.error) {
          window.message.error("Some error has occurred.");
        }
      }
      console.error("Failed to fetch user stats:", err);
    }
  };
  const getTrainingUserStats = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || ""; // Set your base API URL in .env if needed
    const url = apiUrl + "api/trainee/getTrainingUserStats";
    const accessToken = localStorage.getItem("accessToken");

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
        // Add other headers if needed
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          if (res.status === 401) {
            if (window.message && window.message.error) {
              window.message.error(
                "Your session has been expired. Please relogin."
              );
            }
            localStorage.clear();
            window.location.reload();
            throw new Error("Session expired");
          } else {
            if (window.message && window.message.error) {
              window.message.error("Some error has occurred.");
            }
            throw new Error("API error");
          }
        }
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          // handle specific error in response if needed
          // if (window.message && window.message.error) window.message.error(data.userMessage);
        } else {
          setUserStats(data.data[0]);
        }
      })
      .catch((err) => {
        if (err.message !== "Session expired" && err.message !== "API error") {
          if (window.message && window.message.error) {
            window.message.error("Some error has occurred.");
          }
        }
        console.error("Failed to fetch user stats:", err);
      });
  };
  const getOngoingTrainings = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const url = apiUrl + "api/lms/trainee/trainings";
    const accessToken = localStorage.getItem("accessToken");
    const params = new URLSearchParams({
      trainingId: "", // send as empty string if null
      page: 0,
    });
    // Add a timeout to the fetch
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds
    fetch(url + "?" + params.toString(), {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
      signal: controller.signal,
    })
      .then(async (res) => {
        clearTimeout(timeoutId);
        if (!res.ok) {
          if (res.status === 401) {
            if (window.message && window.message.error) {
              window.message.error(
                "Your session has been expired. Please relogin."
              );
            }
            localStorage.clear();
            window.location.reload();
            throw new Error("Session expired");
          } else {
            if (window.message && window.message.error) {
              window.message.error("Some error has occurred.");
            }
            throw new Error("API error");
          }
        }
        return res.json();
      })
      .then((response) => {
        setAllTrainings(response.data || []);
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          if (window.message && window.message.error) {
            window.message.error("Request timed out. Please try again later.");
          }
        } else if (
          err.message !== "Session expired" &&
          err.message !== "API error"
        ) {
          if (window.message && window.message.error) {
            window.message.error("Some error has occurred.");
          }
        }
        console.error("Failed to fetch trainee trainings:", err);
      });
  };
  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);

      try {
        await Promise.all([
          getRiskScore(),
          getLatestTrainings(),
          getTrainingUserStats(),
          getOngoingTrainings(),
          fetchDashboardData(),
        ]);
      } catch (err) {
        // Optional: Handle global error if needed
        console.error("An error occurred while fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  console.log("Loading", loading);
  return (
    <div>
      <div className="welcome-section" style={{ paddingTop: "60px" }}>
        <h2 className="sub-title">Welcome Back, {userInfo.userName}!</h2>
        <p className="sub-subtext">
          Your learning journey continues. Let's make progress today.
        </p>
      </div>
      {loading ? (
        <div>
          <div className="cards-container" style={{ padding: "12px 12px" }}>
            <div className="cards-section">
              <div className="top-row shimmer-row">
                <div className="card black-card shimmer-card">
                  <div className="shimmer"></div>
                </div>
                <div className="card black-card shimmer-card">
                  <div className="shimmer"></div>
                </div>
                <div className="card black-card shimmer-card">
                  <div className="shimmer"></div>
                </div>
              </div>

              <div className="trend-section">
                <h4 className="sub-title"> Course Completion Trend</h4>
                <p className="sub-subtext">
                  Overview of course progress week by month
                </p>
                <div
                  className="shimmer-card"
                  style={{ width: "100%", height: "400px" }}
                >
                  <div className="shimmer"></div>
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 12,
                  }}
                >
                  <h4 className="sub-title">Your Ongoing Courses</h4>
                </div>
                <div className="learning-cards shimmer-row">
                  <div className="learning-card-dashboard shimmer-card">
                    <div className="shimmer"></div>
                  </div>
                  <div className="learning-card-dashboard shimmer-card">
                    <div className="shimmer"></div>
                  </div>
                  <div className="learning-card-dashboard shimmer-card">
                    <div className="shimmer"></div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tallCard_card tall-card"
              style={{ height: "1000px" }}
            >
              <div className="risk-score-card">
                <h2 className="deadline-heading">User's Risk Score</h2>
                <div
                  style={{
                    width: "100%",
                    height: "125px",
                    marginBottom: "40px",
                  }}
                  className="shimmer-card"
                >
                  <div className="shimmer"></div>
                </div>

                <h4 className="deadline-heading">Key Upcoming Deadlines</h4>

                <div className="deadline-card shimmer-card">
                  <div className="shimmer"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="cards-container" style={{ padding: "12px 12px" }}>
            <div className="cards-section">
              <div className="top-row">
                <div className="card black-card">
                  <div className="card-left">
                    {" "}
                    <img
                      className="icon-image-main"
                      src={"/assets/PlayCircle.png"}
                      alt=""
                    />
                    {""}
                  </div>
                  <div className="card-right">
                    <div className="card-number">
                      {userStats && userStats.completed != null
                        ? userStats.completed
                        : 0}
                    </div>
                    <div className="card-text">Completed Training</div>
                  </div>
                </div>

                <div className="card black-card">
                  <div className="card-left">
                    {" "}
                    <img
                      className="icon-image-main"
                      src={"/assets/vector.png"}
                      alt=""
                    />
                    {""}
                  </div>
                  <div className="card-right">
                    <div className="card-number">
                      {userStats && userStats.pending != null
                        ? userStats.pending
                        : 0}
                    </div>
                    <div className="card-text">Pending Training</div>
                  </div>
                </div>

                <div className="card black-card">
                  <div className="card-left">
                    {" "}
                    <img
                      className="icon-image-main"
                      src={"/assets/carbon_task-complete.png"}
                      alt=""
                    />
                    {""}
                  </div>
                  <div className="card-right">
                    <div className="card-number">
                      {userStats && userStats.count != null
                        ? userStats.count
                        : 0}
                    </div>
                    <div className="card-text">Live Training</div>
                  </div>
                </div>
              </div>

              <div className="trend-section">
                <h4 className="sub-title"> Course Completion Trend</h4>

                <p className="sub-subtext">
                  Overview of course progress week by month
                </p>
                <AreaSplineChart
                  categories={categories}
                  assigned={assigned}
                  passed={passed}
                  failed={failed}
                  style={{ width: "100px", height: "400px" }}
                />

                {/* Line Graph */}
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 12,
                  }}
                >
                  <h4 className="sub-title" style={{ padding: "12px" }}>
                    Your Ongoing Courses
                  </h4>
                  <Link
                    to="/trainee-courses"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#001628",
                      textDecoration: "none",
                      fontWeight: 500,
                      marginRight: "18px",
                    }}
                  >
                    View all Courses
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 18,
                        display: "inline-block",
                      }}
                    >
                      &#8594;
                    </span>
                  </Link>
                </div>
                {allTrainings.length > 0 ? (
                  <div className="learning-cards" style={{ padding: "12px" }}>
                    {allTrainings.slice(0, 3).map((item, index) => {
                      const isExpiredAndNotPassed =
                        new Date(item.campaignId.expireAt) < new Date() &&
                        item.successStatus !== "passed";
                      return (
                        <div
                          className="learning-card learning-card-wrapper"
                          key={`inProgress-${index}`}
                        >
                          <div className="image-wrapper">
                            <img
                              className="imageCard"
                              src={
                                item.campaignId.trainingId.coverImage
                                  ? `${imagePrefixUrl}${item.campaignId.trainingId.coverImage}`
                                  : require("assets/images/courses/cover_image.jpg")
                              }
                            />
                            {isExpiredAndNotPassed && (
                              <div className="card-overlay">
                                <span className="overlay-text">
                                  Training Over!!
                                </span>
                              </div>
                            )}
                          </div>

                          <span
                            style={{
                              paddingLeft: "10px",
                              color: "#575857",
                              fontSize: "15px",
                            }}
                          >
                            {item.campaignId.trainingId.totalDuration
                              ? formatDuration(
                                  item.campaignId.trainingId.totalDuration || 0
                                )
                              : "__:__:__"}
                          </span>
                          <h5>{item.campaignId.trainingId.name || " "}</h5>
                          <p>
                            {truncateWords(
                              item.campaignId.trainingId.shortDescription,
                              15
                            )}
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "0 10px",
                            }}
                          >
                            <div>
                              <span
                                style={{
                                  display: "block",
                                  color: "#575857",
                                  fontSize: "13px",
                                }}
                              >
                                Assigned on{" "}
                                {formatDateToDDMM(item.campaignId.createdAt)}
                              </span>
                              <span
                                style={{
                                  display: "block",
                                  color: "#575857",
                                  fontSize: "13px",
                                }}
                              >
                                {item.successStatus === "passed"
                                  ? "Completed"
                                  : "Complete by "}
                                {item.successStatus === "passed"
                                  ? ""
                                  : formatDateToDDMM(item.campaignId.expireAt)}
                              </span>
                            </div>

                            {renderTrainingButton(item)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      flex: 1,
                    }}
                  >
                    <img
                      src={"/assets/noDataBlack.png"}
                      alt=""
                      style={{
                        objectFit: "contain",
                        height: "50%",
                        width: "50%",
                      }}
                    />
                    <h3
                      style={{
                        textAlign: "center",
                        color: "#8c8d8b",
                        marginTop: "0px",
                      }}
                    >
                      {/* You have not completed any course yet. */}
                    </h3>
                  </div>
                )}
              </div>
            </div>

            <div
              className="tallCard_card  tall-card"
              style={{ height: "1000px" }}
            >
              <div className="risk-score-card">
                <h2 className="deadline-heading">User's Risk Score</h2>
                <div
                  style={{
                    width: "100%",
                    height: "125px",
                    marginBottom: "40px",
                  }}
                >
                  <GaugeChart riskScore={riskScore} />
                </div>

                <h4 className="deadline-heading">Key Upcoming Deadlines</h4>

                {allTrainingsCard.length > 0 ? (
                  allTrainingsCard.slice(0, 4).map((training) => (
                    <div className="deadline-card">
                      <div className="scheduled-left">
                        <div className="lecture-name">
                          {training.campaignId.trainingId.name}
                        </div>
                      </div>
                      <div className="scheduled-right">
                        <div className="task-date">
                          {" "}
                          <img
                            className="icon-image"
                            src={"/assets/Group.png"}
                            alt=""
                          />
                          {""}{" "}
                          {moment(training.campaignId.expireAt).format(
                            "MM-DD-YYYY"
                          )}
                        </div>
                        <button className="start-btn">
                          {" "}
                          <Link
                            to={{
                              pathname:
                                training.campaignId.disableRetry &&
                                training.successStatus === "failed"
                                  ? ""
                                  : "/trainee/course-intro/" +
                                    training.campaignId._id +
                                    "/Assigned",
                              trainingInfoProps: training.campaignId.trainingId,
                              campaignInfoProps: training,
                            }}
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            Start Lecture
                          </Link>
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="uk-text-center">
                    <img
                      src="/assets/scheduled.png"
                      alt="No upcoming trainings"
                      style={{
                        maxWidth: "190px",
                        height: "auto",
                        marginTop: "20px",
                      }}
                    />
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      No upcoming deadlines
                    </p>
                  </div>
                )}
                <h4 className="deadline-heading">Scheduled Courses</h4>

                {upcomingTrainings.length > 0 ? (
                  upcomingTrainings.slice(0, 3).map((training) => (
                    <div className="deadline-card">
                      <div className="scheduled-left">
                        <div className="lecture-name">
                          {training.campaignId.trainingId.name}
                        </div>
                        <div className="lecture-time">
                          {" "}
                          <img
                            style={{ paddingBottom: "5px", marginTop: "5px" }}
                            className="icon-image"
                            src={"/assets/Clock.png"}
                            alt=""
                          />
                          <span className="time-text">
                            {moment(training.campaignId.createdAt).format(
                              "MM-DD-YYYY"
                            )}
                            -{" "}
                            {moment(training.campaignId.expireAt).format(
                              "MM-DD-YYYY"
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="scheduled-right">
                        <button className="start-btn">
                          {" "}
                          <Link
                            to={{
                              pathname:
                                training.campaignId.disableRetry &&
                                training.successStatus === "failed"
                                  ? ""
                                  : "/trainee/course-intro/" +
                                    training.campaignId._id +
                                    "/Assigned",
                              trainingInfoProps: training.campaignId.trainingId,
                              campaignInfoProps: training,
                            }}
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            Start Lecture
                          </Link>
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="uk-text-center">
                    <img
                      src="/assets/deadline.png"
                      alt="No upcoming trainings"
                      style={{
                        maxWidth: "190px",
                        height: "auto",
                        marginTop: "20px",
                      }}
                    />
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      No upcoming trainings
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default TraineeHome;
